import { gray2, primaryB, secondaryB } from '../constants/colors'
import React from 'react'
import { Tab, withStyles } from '@material-ui/core'

const AsterTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 12,
    paddingBottom: 12,
    height: 41,
    fontWeight: 600,
    color: gray2,
    opacity: 1,
    '&:hover': {
      backgroundColor: secondaryB,
      borderBottom: '1px solid ' + primaryB,
      color: primaryB
    },
    '&$selected': {
      borderBottom: '3px solid ' + primaryB,
      color: primaryB,
      fontWeight: 700,
      '&:hover': {
        backgroundColor: secondaryB
      }
    },
    '&:focus': {
      color: primaryB
    }
  },
  selected: {}
}))(props => <Tab {...props} />)
export default AsterTab
